export default "__VITE_ASSET__3ed9ea21__"